import { render, staticRenderFns } from "./ThirdStep.vue?vue&type=template&id=ef85cfd0&scoped=true&lang=html&"
import script from "./ThirdStep.vue?vue&type=script&lang=ts&"
export * from "./ThirdStep.vue?vue&type=script&lang=ts&"
import style0 from "./ThirdStep.vue?vue&type=style&index=0&id=ef85cfd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef85cfd0",
  null
  
)

export default component.exports